import React from 'react';

export default function NoRoleAssignedToUser() {
  return "No role assigned to your PwC login account, please contact our services"
}
